<template>
  <div class="terms-use-page">
    <div class="content-container">
      <header class="policy-header">
        <h1>TERMS OF USE</h1>
        <p class="last-updated">Last updated: [31/12/2025]</p>
      </header>

      <section class="intro-section">
        <p>This website is operated by Hangzhou Bailian Hechuang Technology Co., Ltd. (hereinafter referred to as “Alyhome“, “we”, “our” or “our”) and provides the website Alyhome.com and related services (collectively referred to as “Alyhome Online Platform”).</p>
        <p>The purpose of this website is to provide corporate customers and their authorized personnel with product information display, cooperative communication and order management related services related to corporate cooperation. This website is not intended for individual consumers.</p>
        <p>By accessing, browsing or using this website, you are stating that you have read, understood and agree to be bound by these Terms of Use of the Website (hereinafter referred to as “these Terms”). If you do not agree with anything in these Terms, please do not use this website.</p>
      </section>

      <!-- 1. Website and account usage -->
      <section class="policy-section">
        <h2 class="section-title">1. Website and account usage</h2>
        <p>This website is for the use of enterprises and their authorized personnel only. Registered users (including individuals) can only browse publicly available product information and do not have transaction privileges.</p>
        <ul>
          <li><strong>Regular Account:</strong> This refers to users who have completed registration but have not yet established a formal business relationship with us. They do not have the authority to place orders or view company-specific products or order information. They can browse products and information publicly displayed on this website and can contact us for business inquiries through the contact information provided on the website.</li>
          <li><strong>Enterprise Account:</strong> Refers to an enterprise and its authorized personnel who have been verified by us, established a business partnership, and been granted corresponding permissions. They can view enterprise-specific product information; submit orders or cooperation requests; and view historical order records related to their enterprise. Specific permissions for an enterprise account are subject to the permissions actually granted by us.</li>
        </ul>
      </section>

      <!-- 2. Intellectual property -->
      <section class="policy-section">
        <h2 class="section-title">2. Intellectual property</h2>
        <ul>
          <li><strong>Ownership:</strong> All content on the website, including but not limited to product designs, product catalog images, specifications, text, graphics, logos and software code, is the exclusive property of Alyhome or its licensors and is protected by Chinese and international copyright laws.</li>
          <li><strong>Trademarks:</strong> "Alyhome" and our product names are trademarks of our company. You may not use them without our prior written permission.</li>
          <li><strong>Unauthorized scraping is prohibited:</strong> It is strictly forbidden to use data mining, bots, "scraping" or similar data collection tools to extract directory data, prices or images from websites for use in competitors' databases or for resale.</li>
        </ul>
      </section>

      <!-- 3. Product Information and Catalog -->
      <section class="policy-section">
        <h2 class="section-title">3. Product Information and Catalog</h2>
        <ul>
          <li><strong>Accuracy:</strong> We strive to ensure the accuracy of our product catalogs and descriptions. However, we do not guarantee that product descriptions, images, or prices are completely accurate.</li>
          <li><strong>Color and Finish:</strong> Due to differences in monitor settings, the actual product color and finish may differ from the image displayed on your monitor. We cannot guarantee that any colors displayed on your device will be accurate.</li>
          <li><strong>Pricing Error:</strong> If there is a pricing error in our product catalog or website, we reserve the right to cancel any product ordered at the incorrect price, even if the order has been confirmed and your payment has been charged. If the payment has been charged, we will provide a full refund.</li>
        </ul>
      </section>

      <!-- 4. Order and Contract Details (Important) -->
      <section class="policy-section">
        <h2 class="section-title">4. Order and Contract Details (Important)</h2>
        
        <h3>Order nature</h3>
        <p>This website only provides information display and order application functions. All legally binding contracts must be confirmed offline by both parties.</p>
        
        <h3>Contract established</h3>
        <p>Any legally binding contract shall be based on a separate written contract signed offline by both parties or other official documents confirmed by both parties.</p>
        
        <h3>Payment Instructions</h3>
        <p>This website does not provide any online payment or collection functions, nor does it process or collect any bank card, credit card or other payment information through the website. All payments are completed through offline settlement methods, and this website assumes no responsibility for payment processing.</p>
      </section>

      <!-- 5. Disclaimer -->
      <section class="policy-section">
        <h2 class="section-title">5. Disclaimer</h2>
        <p>This website and all products are provided "as is" and "as available" without any express or implied warranties of any kind, including but not limited to implied warranties of merchantability, fitness for a particular purpose or non-infringement.</p>
      </section>

      <!-- 6. Limitation of liability -->
      <section class="policy-section">
        <h2 class="section-title">6. Limitation of liability</h2>
        <p>To the fullest extent permitted by law, ALYHOME shall not be liable for any indirect, incidental, special, consequential, or punitive damages (including loss of profits) arising out of or related to your use of this website or products, even if we have been advised of the possibility of such damages.</p>
      </section>

      <!-- 7. Compensation -->
      <section class="policy-section">
        <h2 class="section-title">7. Compensation</h2>
        <p>You agree to indemnify and hold harmless Alyhome and its officers, directors, employees, and agents from and against any claims, liabilities, damages, and costs (including attorneys' fees) arising out of or relating to your breach of these Terms or misuse of the website (e.g., uploading malicious code or stealing intellectual property).</p>
      </section>

      <!-- 8. Jurisdiction and Dispute Resolution -->
      <section class="policy-section">
        <h2 class="section-title">8. Jurisdiction and Dispute Resolution</h2>
        <p>The interpretation and validity of these Terms of Use, and any dispute arising from the general browsing and use of the website, shall be governed by and construed in accordance with the laws of the People's Republic of China and shall be subject to the exclusive jurisdiction of the People's Court with jurisdiction in the location of the parent company in China.</p>
        <p>Any commercial disputes arising from the creation of orders or confirmation of transaction intentions through this website shall be submitted to the Singapore International Arbitration Centre (SIAC) for arbitration in accordance with its rules. The place of arbitration shall be Singapore.</p>
      </section>

      <!-- 9. Terms and Conditions Change -->
      <section class="policy-section">
        <h2 class="section-title">9. Terms and Conditions Change</h2>
        <p>We reserve the right to modify these terms at any time. The modified terms will take effect immediately upon publication on this website. Your continued use of this website after the modification is published constitutes your acceptance of the modified terms.</p>
      </section>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TermsOfUse',
}
</script>

<style scoped>
.terms-use-page {
  background-color: #FAF9F7;
  color: #333;
  font-family: "NotoSerif", sans-serif;
  line-height: 1.6;
  padding: 40px 20px 60px;
  display: flex;
  justify-content: center;
}

.content-container {
  max-width: 900px;
  width: 100%;
  background: transparent;
}

.policy-header {
  text-align: center;
  margin-bottom: 40px;
}

.policy-header h1 {
  font-size: 28px;
  font-weight: bold;
  letter-spacing: 1px;
  margin-bottom: 10px;
}

.last-updated {
  font-size: 16px;
  color: #666;
}

.intro-section p {
  margin-bottom: 15px;
  font-size: 16px;
}

.policy-section {
  margin-top: 40px;
}

.section-title {
  font-size: 20px;
  font-weight: bold;
  border-bottom: none;
  margin-bottom: 20px;
}

h3 {
  font-size: 16px;
  font-weight: bold;
  margin: 20px 0 10px 0;
}

p {
  margin-bottom: 15px;
  font-size: 16px;
}

ul {
  margin-bottom: 20px;
  padding-left: 45px;
}

li {
  margin-bottom: 12px;
  font-size: 16px;
  list-style-type: disc !important; 
  display: list-item; 
}

li strong {
  font-weight: bold;
}

@media (max-width: 600px) {
  .policy-header h1 {
    font-size: 22px;
  }
  .section-title {
    font-size: 18px;
  }
}
@media (max-width: 768px) {
  .main div,.main p,.main li,.section-title,h1,h3{
    font-size: 4rem !important;
  }
  .content-container{
    max-width: 90%;
  }
}
</style>